import { render } from "./NoticeGestorColab.vue?vue&type=template&id=40f3e00f&scoped=true"
import script from "./NoticeGestorColab.vue?vue&type=script&lang=js"
export * from "./NoticeGestorColab.vue?vue&type=script&lang=js"

import "./NoticeGestorColab.vue?vue&type=style&index=0&id=40f3e00f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40f3e00f"]])

export default __exports__